import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AuthService } from '@core/services';

@Component({
    selector: 'app-email-verification',
    templateUrl: './email-verification.component.html',
    styleUrls: ['./email-verification.component.scss'],
    standalone: false,
})
export class EmailVerificationComponent implements OnInit {
    success?: boolean;
    message?: string;

    constructor(private route: ActivatedRoute, private authService: AuthService) {}

    ngOnInit(): void {
        this.success = undefined;
        this.message = undefined;
        this.authService.verifyEmail(this.route.snapshot.params.code).subscribe({
            next: () => {
                this.success = true;
                this.message = $localize`:@@resendEmail.success.requestSuccessful:Je email werd geverifieerd`;
            },
            error: (err: Error) => {
                console.error('Something went wrong while requesting new verification email:', err);
                this.message = $localize`:@@resendEmail.error.requestFailed:Er ging iets fout tijdens het opnieuw aanvragen van een verificatiemail. Probeer later opnieuw.`;
                this.success = false;
            },
        });
    }
}
